import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PasswordVisibilityState {
  [key: string]: boolean; // Store visibility per field name
}

const initialState: PasswordVisibilityState = {};

const passwordVisibilitySlice = createSlice({
  name: "passwordVisibility",
  initialState,
  reducers: {
    toggle: (state, action: PayloadAction<string>) => {
      const field = action.payload;
      state[field] = !state[field]; // Toggle only the specific field
    },
  },
});

export const { toggle } = passwordVisibilitySlice.actions;
export default passwordVisibilitySlice.reducer;
